import React from "react";
import * as RB from "react-bootstrap";
import * as utils from "../../../Utils/comman";
import DatePicker from "react-datepicker";
import { useSelector } from "react-redux";
import Select from "react-select";

function PersonalInfo({
  tempStudentProfilePic,
  setTempStudentProfile,
  setStudentProfilePic,
  isEdit,
  formData,
  handleInputChange,
  mobileNoError,
  setFormData,
  isCourierSameAsPermanent,
  handleCheckboxChange,
}) {
  const status = [
    { id: "", name: "Select an option..." },
    { id: "1", name: "Active" },
    { id: "0", name: "Inactive" },
  ];
  const states = useSelector((state) => state.state.states);
  const districts = useSelector((state) => state.district.districts);
  const cities = useSelector((state) => state.city.cities);
  const handleStudentUpload = (e) => {
    // const file = e.target.files[0];
    //   const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
    var link = document.getElementById("studentProfilePic");
    link.click();
  };

  const handleStudentFileChange = (e) => {
    setTempStudentProfile(URL.createObjectURL(e.target.files[0]));
    setStudentProfilePic(e.target.files[0]);
  };

  const stateOptions = states?.map((state) => ({
    value: state.state_code,
    label: state.state_name,
  }));

  const districtOptions = districts?.map((dis) => ({
    value: dis.district_code,
    label: dis.district_name,
  }));

  const cityOptions = cities?.map((city) => ({
    value: city.id,
    label: city.city_name,
  }));

  return (
    <>
      <h6>Personal Information</h6>
      <hr className="hr-lg mt-1" />

      <RB.Row>
        <RB.Col md={3}>
          <RB.Row>
            <div className="col-md-10 text-center">
              <div className="profile-photo rounded mb-3">
                <img
                  src={tempStudentProfilePic}
                  className="img-fluid rounded"
                  id="img_profile4"
                  alt="profile"
                />
              </div>
              <a
                className="btn btn-block btn-outline-primary upload-button"
                id="btn-f-upload"
                onClick={handleStudentUpload}
              >
                Upload Photo
              </a>
              <input
                id="studentProfilePic"
                type="file"
                className="form-control d-none"
                name="studentProfilePic"
                onChange={handleStudentFileChange}
              />
            </div>
          </RB.Row>
        </RB.Col>
        <RB.Col md={9}>
          <RB.Row>
            {isEdit && (
              <RB.Col md={6}>
                {" "}
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="Employee ID"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter Employee ID"
                      name="employeeId"
                      value={formData.employeeId}
                      onChange={handleInputChange}
                      required
                      readOnly
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
            )}
            <RB.Col md={6}>
              <div className="mb-3">
                <RB.FloatingLabel
                  label="First Name"
                  className="floating-label-fancy"
                >
                  <RB.Form.Control
                    type="text"
                    placeholder="Enter First Name"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleInputChange}
                    required
                    maxLength={32}
                  />
                </RB.FloatingLabel>
              </div>
            </RB.Col>
            <RB.Col md={6}>
              <div className="mb-3">
                <RB.FloatingLabel
                  label="Middle Name"
                  className="floating-label-fancy"
                >
                  <RB.Form.Control
                    type="text"
                    placeholder="Enter Middle Name"
                    name="middleName"
                    value={formData.middleName}
                    onChange={handleInputChange}
                    maxLength={32}
                  />
                </RB.FloatingLabel>
              </div>
            </RB.Col>
            <RB.Col md={6}>
              <div className="mb-3">
                <RB.FloatingLabel
                  label="Last Name"
                  className="floating-label-fancy"
                >
                  <RB.Form.Control
                    type="text"
                    placeholder="Enter Last Name"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleInputChange}
                    required
                    maxLength={32}
                  />
                </RB.FloatingLabel>
              </div>
            </RB.Col>
            <RB.Col md={6}>
              <div className="mb-3">
                <RB.FloatingLabel
                  label="Official Email"
                  className="floating-label-fancy"
                >
                  <RB.Form.Control
                    type="email"
                    placeholder="Enter Email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                  />
                </RB.FloatingLabel>
              </div>
            </RB.Col>
            <RB.Col md={6}>
              <div className="mb-3">
                <RB.FloatingLabel
                  label="Personal Email"
                  className="floating-label-fancy"
                >
                  <RB.Form.Control
                    type="email"
                    placeholder="Enter Email"
                    name="personalEmail"
                    value={formData.personalEmail}
                    onChange={handleInputChange}
                  />
                </RB.FloatingLabel>
              </div>
            </RB.Col>
            <RB.Col md={6}>
              <div className="mb-3">
                <RB.FloatingLabel
                  label="Mobile No"
                  className="floating-label-fancy"
                >
                  <RB.Form.Control
                    type="text"
                    placeholder="Enter Email"
                    name="mobileNo"
                    value={formData.mobileNo}
                    onChange={handleInputChange}
                  />
                  {mobileNoError && (
                    <span className="text-danger">
                      Please provide a valid 10-digit emergency contact number.
                    </span>
                  )}
                </RB.FloatingLabel>
              </div>
            </RB.Col>
            <RB.Col md={6}>
              <div className="mb-3 mt-3">
                <RB.FloatingLabel
                  label="Date Of Birth"
                  className={`floating-label-fancy ${
                    formData.dob ? "dateSelected" : "dateempty"
                  }`}
                >
                  <DatePicker
                    selected={formData.dob}
                    onChange={(date) => setFormData({ ...formData, dob: date })}
                    dateFormat="dd-MM-yyyy"
                    className={`form-control`}
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    // placeholderText="Select Date of Birth"
                    // placeholderText="Select Date of Birth"
                    maxDate={new Date()}
                  />
                </RB.FloatingLabel>
              </div>
            </RB.Col>

            <RB.Col md={6}>
              <div className="mb-3">
                <RB.FloatingLabel
                  label="Based Location"
                  className="floating-label-fancy"
                >
                  <RB.Form.Control
                    as="textarea"
                    type="text"
                    placeholder="Enter Based Location"
                    name="based_location"
                    value={formData.based_location}
                    onChange={handleInputChange}
                    required
                  />
                </RB.FloatingLabel>
              </div>
            </RB.Col>
          </RB.Row>
          <RB.Row>
            <RB.Col md={5}>
              <div className="mb-3">
                <RB.FloatingLabel
                  label="Permanent Address"
                  className="floating-label-fancy"
                >
                  <RB.Form.Control
                    as="textarea"
                    type="text"
                    placeholder="Enter Location"
                    style={{ height: "90px" }}
                    name="permanentAdd"
                    value={formData.permanentAdd}
                    onChange={handleInputChange}
                  />
                </RB.FloatingLabel>
              </div>
            </RB.Col>
            <RB.Col className="d-flex justify-content-center flex-column col-md text-center">
              <div className="mb-3">
                <RB.Form.Check
                  type="checkbox"
                  id="sameAsPermanent"
                  checked={isCourierSameAsPermanent}
                  onChange={handleCheckboxChange}
                />
                <label
                  htmlFor="sameAsPermanent"
                  className="d-block cursor-pointer"
                >
                  Same as Permanent Address
                </label>
              </div>
            </RB.Col>

            <RB.Col md={5}>
              <div className="mb-3">
                <RB.FloatingLabel
                  label="Courier Address (Full)"
                  className="floating-label-fancy"
                >
                  <RB.Form.Control
                    as="textarea"
                    type="text"
                    placeholder="Enter Courier Address"
                    style={{ height: "90px" }}
                    name="courierAdd"
                    value={formData.courierAdd}
                    onChange={handleInputChange}
                  />
                </RB.FloatingLabel>
              </div>
            </RB.Col>
          </RB.Row>
        </RB.Col>
      </RB.Row>

      <RB.Row>
        <RB.Col md={4} className="mt-3">
          <Select
            options={stateOptions}
            value={stateOptions.find((opt) => opt.value === formData.state)}
            onChange={(selectedOption) =>
              handleInputChange({
                target: {
                  name: "state",
                  value: selectedOption ? selectedOption.value : "",
                },
              })
            }
            isClearable
            placeholder="Select State"
            className="bom-productName-select"
            classNamePrefix="react-select"
          />
        </RB.Col>

        <RB.Col md={4} className="mt-3">
          <Select
            options={districtOptions}
            value={districtOptions.find(
              (opt) => opt.value === formData.district
            )}
            onChange={(selectedOption) =>
              handleInputChange({
                target: {
                  name: "district",
                  value: selectedOption ? selectedOption.value : "",
                },
              })
            }
            isClearable
            placeholder="Select District"
            className="bom-productName-select"
            classNamePrefix="react-select"
          />
        </RB.Col>

        <RB.Col md={4} className="mt-3">
          <Select
            options={cityOptions}
            value={cityOptions.find((opt) => opt.value === formData.city)}
            onChange={(selectedOption) =>
              handleInputChange({
                target: {
                  name: "city",
                  value: selectedOption ? selectedOption.value : "",
                },
              })
            }
            isClearable
            placeholder="Select City"
            className="bom-productName-select"
            classNamePrefix="react-select"
          />
        </RB.Col>
        <RB.Col md={4}>
          <div className="mb-3">
            <RB.FloatingLabel label="Area" className="floating-label-fancy">
              <RB.Form.Control
                type="text"
                placeholder="Enter Area"
                name="area"
                value={formData.area}
                onChange={handleInputChange}
              />
            </RB.FloatingLabel>
          </div>
        </RB.Col>
        <RB.Col md={4}>
          <div className="mb-3">
            <RB.FloatingLabel
              label="PF UAN No."
              className="floating-label-fancy"
            >
              <RB.Form.Control
                type="text"
                placeholder="Enter PF UAN No."
                name="pfUan"
                value={formData.pfUan}
                onChange={handleInputChange}
              />
            </RB.FloatingLabel>
          </div>
        </RB.Col>

        <RB.Col md={4}>
          <div className="mb-3">
            <RB.FloatingLabel
              label="Mother Name"
              className="floating-label-fancy"
            >
              <RB.Form.Control
                type="text"
                placeholder="Enter Mother's Name"
                name="motherName"
                value={formData.motherName}
                onChange={handleInputChange}
              />
            </RB.FloatingLabel>
          </div>
        </RB.Col>
        <RB.Col md={4}>
          <div className="mb-3">
            <RB.FloatingLabel label="Gender" className="floating-label-fancy">
              <RB.Form.Select
                name="gender"
                value={formData.gender}
                onChange={handleInputChange}
              >
                <option value="">Select Gender</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
                <option value="other">Other</option>
              </RB.Form.Select>
            </RB.FloatingLabel>
          </div>
        </RB.Col>
        <RB.Col md={4}>
          <div className="mb-3">
            <RB.FloatingLabel
              label="Marital Status"
              className="floating-label-fancy"
            >
              <RB.Form.Select
                name="maritalStatus"
                value={formData.maritalStatus}
                onChange={handleInputChange}
              >
                <option value="">Select Marital Status</option>
                <option value="married">Married</option>
                <option value="unmarried">Unmarried</option>
              </RB.Form.Select>
            </RB.FloatingLabel>
          </div>
        </RB.Col>
        <RB.Col md={4}>
          <div className="mb-3">
            <RB.FloatingLabel
              label="Blood Group"
              className="floating-label-fancy"
            >
              <RB.Form.Control
                type="text"
                placeholder="Enter Blood Group"
                name="bloodGroup"
                value={formData.bloodGroup}
                onChange={handleInputChange}
              />
            </RB.FloatingLabel>
          </div>
        </RB.Col>
        <RB.Col md={4}>
          <div className="mb-3">
            <RB.FloatingLabel label="Status" className="floating-label-fancy">
              <RB.Form.Control
                as="select"
                name="isActive"
                value={formData.isActive}
                onChange={handleInputChange}
                required
              >
                {status.map((role) => (
                  <option key={role.id} value={role.id}>
                    {role.name}
                  </option>
                ))}
              </RB.Form.Control>
            </RB.FloatingLabel>
          </div>
        </RB.Col>
      </RB.Row>
    </>
  );
}

export default PersonalInfo;
